export enum EUserType {
    admin,
    courier,
}
